import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ProductsSection from './components/ProductsSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

export default function HomePage() {
  return (
    <div className="w-full" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
      <SeoJsonLd />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <FeaturesSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
